import type { ApiType } from "@server/routes/api";
import { hc } from "hono/client";

declare const sessionId: string;

export const apiBaseUrl =
  (typeof location !== "undefined" ? location.origin : "") + "/api";

export const apiHeaders = {
  "X-Session-Id": typeof sessionId !== "undefined" ? sessionId : "",
  "X-Requested-With": "XMLHttpRequest",
};

export const api = hc<ApiType>(apiBaseUrl, {
  headers: apiHeaders,
});
